<template>
  <div class="user-status">
    <span
      v-if="user.meta.userStatusType"
      :class="['presence-icon', {
        'sm-presence-icon': collapsed,
        'responsive-presence-icon': responsiveIcon
      }]"
      :style="{ 'background-color': presenceIconColor }"
      @mouseover="toggleVisibleUserStatus"
      @mouseleave="toggleVisibleUserStatus"
    />
    <span
      v-if="user.meta.userStatusType"
      :class="['bordering-presence-icon', {
        'sm-bordering-presence-icon': collapsed,
        'responsive-bordering-presence-icon': responsiveIcon
      }]"
    />
    <transition name="fade">
      <span
        v-if="visibleUserStatus"
        class="hover-status-type"
      >
        {{ $t(`models.user.statusType.${user.meta.userStatusType}`) }}
      </span>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ProaUserStatusIcon',
  props: {
    user: Object,
    collapsed: Boolean,
    responsiveIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleUserStatus: false
    }
  },
  computed: {
    presenceIconColor: function () {
      let iconColor = ''
      switch(this.user.meta.userStatusType) {
        case 'normal':
          iconColor = '#46b4f0'
          break
        case 'meeting':
          iconColor = '#3ebe3e'
          break
        case 'busy':
          iconColor = '#f08200'
          break
      }
      return iconColor
    }
  },
  methods: {
    toggleVisibleUserStatus: function() {
      if (this.collapsed) return
      this.visibleUserStatus = !this.visibleUserStatus
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/mediaquery";

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.user-status {
  position: relative;
  display: flex;
  align-items: center;
  .presence-icon {
    width: 13px;
    height: 13px;
    border-radius: 50%;
    display: inline-block;
    z-index: 1;
  }
  .sm-presence-icon {
    width: 10px !important;
    height: 10px !important;
  }
  .responsive-presence-icon {
    width: 10px;
    height: 10px;
    @include mq(lg) {
      width: 13px;
      height: 13px;
    }
  }

  .bordering-presence-icon {
    position: absolute;
    width: 17px;
    height: 17px;
    left: -2px;
    border-radius: 50%;
    background-color: #fff;
  }
  .sm-bordering-presence-icon {
    width: 14px !important;
    height: 14px !important;
  }
  .responsive-bordering-presence-icon {
    width: 14px;
    height: 14px;
    @include mq(lg) {
      width: 17px;
      height: 17px;
    }
  }

  .hover-status-type {
    position: absolute;
    top: -23px;
    left: -15px;
    font-size: 10px;
    color: #fff;
    background-color: $secondary-color;
    padding: 2px 5px;
  }
}
</style>
